import { useTranslation } from 'react-i18next';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { Box } from '@/UI/Box/Box';
import { Tooltip } from '@/UI/Tooltip/Tooltip';
import { Typography } from '@/UI/AppTypography/AppTypography';
import { I18N_KEYS } from '@/language/keys';

interface Props {
  /** "sm" (default): compact inline tag shown alongside a credit amount. "md": standalone pill with tooltip, used as fallback when no credits are shown. */
  size?: 'sm' | 'md';
}

export const ByokBadge = ({ size = 'sm' }: Props) => {
  const { t } = useTranslation();

  if (size === 'md') {
    const label = t(I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_LABEL);
    const tooltip = t(I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_TOOLTIP);
    return (
      <Tooltip title={tooltip} placement="top">
        <Box
          component="span"
          aria-label={tooltip}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'flex-start',
            width: 'fit-content',
            maxWidth: '100%',
            px: 0.75,
            py: 0.25,
            borderRadius: 1,
            bgcolor: 'transparent',
            border: `1px solid ${token.border}`,
            flexShrink: 0,
            cursor: 'default',
          }}
        >
          <Typography component="span" variant="label-xs-rg" sx={{ color: token.text }}>
            {label}
          </Typography>
        </Box>
      </Tooltip>
    );
  }

  const tooltip = t(I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_TOOLTIP);
  return (
    <Tooltip title={tooltip} placement="top">
      <Box
        component="span"
        aria-label={tooltip}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          px: '4px',
          borderRadius: '2px',
          bgcolor: 'transparent',
          border: `1px solid ${token.border}`,
          flexShrink: 0,
          cursor: 'default',
        }}
      >
        <Typography component="span" variant="label-xs-rg" sx={{ color: token.text }}>
          {t(I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_LABEL)}
        </Typography>
      </Box>
    </Tooltip>
  );
};
